import type { LeadTemperature } from '../types/contracts';

const TEMP_STYLE: Record<LeadTemperature, { label: string; cls: string }> = {
  hot: { label: 'ساخن 🔥', cls: 'bg-rose-50 text-rose-700 border-rose-100' },
  warm: { label: 'دافئ', cls: 'bg-amber-50 text-amber-700 border-amber-100' },
  cold: { label: 'بارد', cls: 'bg-sky-50 text-sky-700 border-sky-100' },
};

export function TemperatureBadge({ temperature }: { temperature: LeadTemperature }) {
  const s = TEMP_STYLE[temperature];
  return <span className={`inline-flex items-center px-2 py-0.5 rounded-full border text-[10px] font-black tracking-wide ${s.cls}`}>{s.label}</span>;
}

export function LeadScore({ score, temperature, compact }: { score: number; temperature: LeadTemperature; compact?: boolean }) {
  const color = score >= 80 ? 'text-rose-600' : score >= 55 ? 'text-amber-600' : 'text-sky-600';
  return (
    <span className="inline-flex items-center gap-1.5">
      <span className={`text-sm font-black ${color}`}>{score}</span>
      {!compact && <TemperatureBadge temperature={temperature} />}
    </span>
  );
}
